var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgPrintLabelsIconN = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.333 3.33203C13.7012 3.33203 13.9997 3.63051 13.9997 3.9987V6.66536H15.9997C16.3679 6.66536 16.6663 6.96384 16.6663 7.33203V13.9987C16.6663 14.3669 16.3679 14.6654 15.9997 14.6654H13.9997V15.9987C13.9997 16.3669 13.7012 16.6654 13.333 16.6654H6.66634C6.29815 16.6654 5.99967 16.3669 5.99967 15.9987V14.6654H3.99967C3.63149 14.6654 3.33301 14.3669 3.33301 13.9987V7.33203C3.33301 6.96384 3.63149 6.66536 3.99967 6.66536H5.99967V3.9987C5.99967 3.63051 6.29815 3.33203 6.66634 3.33203H13.333ZM12.6663 13.332H7.33301V15.332H12.6663V13.332ZM15.333 7.9987H4.66634V13.332H5.99967V12.6654C5.99967 12.2972 6.29815 11.9987 6.66634 11.9987H13.333C13.7012 11.9987 13.9997 12.2972 13.9997 12.6654V13.332H15.333V7.9987ZM7.33301 8.66536V9.9987H5.33301V8.66536H7.33301ZM12.6663 4.66536H7.33301V6.66536H12.6663V4.66536Z",
    fill: "#FC6328"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgPrintLabelsIconN, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/PrintLabelsIconN.547440a8.svg";
export { ForwardRef as ReactComponent };